<template>
    <div id="app" class="fillcontain" v-cloak>
        <router-view></router-view>
    </div>
</template>
<script>
import {_getLocalStore, _setLocalStore} from '@/lib/storage'
    export default {
        name: 'app',
        created(){
            if(_getLocalStore('language') == 'cn'){
                this.setCurThemeType('ceWrap')
            }else if(_getLocalStore('language') == 'en'){
                this.setCurThemeType('enWrap')
            }
        },
        components:{

        },
        methods:{


        },
        mounted() {

        }
    }
</script>

<style lang="scss">
    @import "assets/css/reset.scss";

</style>
<style>
    /*@import "assets/css/vue2editor.css";*/
    /* @import "assets/css/vue-quill-editor.css"; */
    @import "assets/css/iconfont/iconfont.css";
    /*@import "//at.alicdn.com/t/font_1901623_ziad2msixmq.css";*/
    /* @import "//at.alicdn.com/t/font_1901623_kpv0bx4gjr.css"; */
    /* @import "assets/css/swiper.min.css"; */

</style>
